var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCoverPhoto(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1164,
    height: 200,
    viewBox: "0 0 1164 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_254_1993)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1164,
    height: 200,
    fill: "#D1F1C9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 88,
    cy: 43,
    r: 108,
    fill: "#6366F1",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 250,
    r: 250,
    transform: "matrix(-0.242044 -0.970265 -0.970265 0.242044 1426.69 132.08)",
    fill: "#6366F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318 -54L318 37H222L318 -54Z",
    fill: "#6366F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318 37L318 151H222L318 37Z",
    fill: "#6366F1",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414 -54L414 37H318L414 -54Z",
    fill: "#6366F1",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414 37L414 151H318L414 37Z",
    fill: "#41A128"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678 54L678 145H582L678 54Z",
    fill: "#41A128"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678 145L678 259H582L678 145Z",
    fill: "#6366F1",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M774 54L774 145H678L774 54Z",
    fill: "#6366F1",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M774 145L774 259H678L774 145Z",
    fill: "#6366F1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 483.5,
    cy: 68.5,
    r: 7.5,
    fill: "#3BAEFE"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 802.5,
    cy: 91.5,
    r: 7.5,
    fill: "#3BAEFE"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 817.5,
    cy: 30.5,
    r: 7.5,
    fill: "#3EC5E3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 674.5,
    cy: 47.5,
    r: 7.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 574.818,
    y1: 41.2724,
    x2: 594.818,
    y2: 36.2724,
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.75,
    x2: 20.6155,
    y2: -0.75,
    transform: "matrix(0.18032 0.983608 0.983608 -0.18032 584.142 28.3611)",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 867.818,
    y1: 75.2724,
    x2: 887.818,
    y2: 70.2724,
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.75,
    x2: 20.6155,
    y2: -0.75,
    transform: "matrix(0.18032 0.983608 0.983608 -0.18032 877.142 62.3611)",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 487.818,
    y1: 135.911,
    x2: 507.818,
    y2: 130.911,
    stroke: "#6366F1",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.75,
    x2: 20.6155,
    y2: -0.75,
    transform: "matrix(0.18032 0.983608 0.983608 -0.18032 497.142 123)",
    stroke: "#6366F1",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 203.818,
    y1: 108.911,
    x2: 223.818,
    y2: 103.911,
    stroke: "#3BAEFE",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.75,
    x2: 20.6155,
    y2: -0.75,
    transform: "matrix(0.18032 0.983608 0.983608 -0.18032 213.142 96)",
    stroke: "#3BAEFE",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 847.818,
    y1: 126.272,
    x2: 867.818,
    y2: 121.272,
    stroke: "#3BAEFE",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.75,
    x2: 20.6155,
    y2: -0.75,
    transform: "matrix(0.18032 0.983608 0.983608 -0.18032 857.142 113.361)",
    stroke: "#3BAEFE",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_254_1993"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1164,
    height: 200,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoverPhoto);
export default __webpack_public_path__ + "static/media/Cover Photo.981b8d94d8ae613eb6effc1f734494f9.svg";
export { ForwardRef as ReactComponent };